import { AuditLogDto } from '@sr/dto';
import { extractNestJsErrorMessage } from 'shared/api/rtk-query';
import { AuditLogsQuery, auditApi } from './api';

type UseAuditLogsOptions = {
  skip?: boolean;
};

type UseAuditLogsResult = {
  logs: AuditLogDto[];
  totalItemsCount: number;
  isLoading: boolean;
  isFetching: boolean;
  error?: string;
};

export const useAuditLogs = (params: AuditLogsQuery, options?: UseAuditLogsOptions): UseAuditLogsResult => {
  const { data, error, isLoading, isFetching } = auditApi.useGetAuditLogsQuery(params, {
    skip: options?.skip,
  });

  return {
    logs: data?.items ?? [],
    totalItemsCount: data?.totalItemsCount ?? 0,
    isLoading,
    isFetching,
    error: error ? extractNestJsErrorMessage(error) : undefined,
  };
};
